export const enum UserState {
  LOADING = -1,
  LOGGEDIN = 1,
  LOGGEDOUT = 0,
}
export interface AWSUser {
  "custom:addedBy": string;
  "custom:companyId": string;
  "custom:userType": UserType;
  email: string;
  email_verified: boolean;
  jwtToken: string;
  name: string;
  sub: string;
}

export interface UserGroup {
  _id: string;
  groupName: string;
  groupDescription: string;
  createdBy: User;
  createdAt: string;
  users: User[];
}

export interface User {
  sub: string;
  name: string;
  email: string;
  userType: UserType;
  _id: string;
  country?: string;
  profilePicture?: string;
  timeZone?: string;
  mobile?: string;
  active_flag?: boolean;
  dialCode?: string;
  user_status?: UserStatus;
  email_verified?: boolean;
  jwtToken?: string;
  createdAt?: string;
  createdBy?: User;
  groups?: UserGroup[];
  companyLogo?: string;
  companyName?: string;
}

export interface ListUsersName {
  users: User[];
}

export const enum UserType {
  USER = "user",
  ADMIN = "admin",
}

export const enum UserStatus {
  CONFIRMED = "CONFIRMED",
  UNCONFIRMED = "Unconfirmed",
}

export const UserTypes = [UserType.ADMIN, UserType.USER];
